<template>
  <div class="ma-4 px-4">
    <searchBarFilter
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      @updateBatch="(v) => ((searchBatch = v), (search = v))"
      @updateYear="(v) => ((searchYear = v), (search = v))"
      :showFilter="true"
      headerText=""
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="programApplicationSchedules"
            fixed-header
            :custom-filter="customFilter"
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon
                small
                class="mr-2"
                color="accent"
                @click="edit(item)"
                :disabled="
                  checkDateRange(item.course_start_date, item.end_date)
                "
              >
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.program_id`]="{ value }">
              {{ getProgram(value) }}
            </template>
            <template #[`item.start_date`]="{ value }">
              {{ formatDate(value) }}
            </template>
            <template #[`item.course_start_date`]="{ value }">
              {{ formatDate(value) }}
            </template>
            <template #[`item.end_date`]="{ value }">
              {{ formatDate(value) }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createProgramApplicationSchedule"
        @update="updateProgramApplicationSchedule"
        :program_application="program_application"
        :programs="programs"
        :edit="editMode"
      />
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/programApplicationSchedule/form.vue";
import searchBarFilter from "@/components/searchBarFilter.vue";
import { ProgramApplicationScheduleHeaders } from "@/constants/headers";
export default {
  components: {
    formDialog,
    searchBarFilter,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      program_application: {},
      deleteDialog: false,
      currentItem: {},
      programApplicationSchedules: [],
      search: "",
      searchBatch: null,
      searchYear: null,
      headers: ProgramApplicationScheduleHeaders,
      programs: [],
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Programme" }]);
    this.initialise();
  },
  methods: {
    async initialise() {
      this.getPrgApplicationSchedule();
      await this.getPrograms();
    },

    async getPrograms() {
      await this.$axios
        .get("programs")
        .then((res) => {
          this.programs = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrgApplicationSchedule() {
      await this.$axios
        .get("program_application_schedules")
        .then((res) => {
          this.programApplicationSchedules = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async createProgramApplicationSchedule(data) {
      await this.$axios
        .post("program_application_schedules", {
          program_application_schedule: data,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Programme Application Schedule created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateProgramApplicationSchedule(data) {
      await this.$axios
        .put("program_application_schedules/" + data.id, {
          program_application_schedule: data,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Programme Application Schedule updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    edit(item) {
      this.program_application = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.deleteDialog = false;
      this.program_application = {};
    },
    getProgram(id) {
      const program = this.programs.find((program) => program.id == id);
      return (
        program?.degree?.short_name +
        (program?.specialization ? " - " + program?.specialization : "")
      );
    },
    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    customFilter(value, search, item) {
      const formattedStartDate = this.formatDate(item.start_date);
      const formattedEndDate = this.formatDate(item.end_date);
      const formattedCourseStartDate = this.formatDate(item.course_start_date);
      const programName = this.getProgram(item.program_id);

      const textMatch =
        search === "" ||
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        formattedStartDate.includes(search) ||
        formattedEndDate.includes(search) ||
        formattedCourseStartDate.includes(search) ||
        programName.toLowerCase().includes(search.toLowerCase());

      const yearMatch =
        !this.searchYear || String(item.year) === String(this.searchYear);

      const batchMatch =
        !this.searchBatch ||
        String(item.batch).toLowerCase() === this.searchBatch.toLowerCase();

      return textMatch && yearMatch && batchMatch;
    },
    checkDateRange(course_start_date, end_date) {
      const startDate = new Date(course_start_date);
      const endDate = new Date(end_date);
      return startDate <= endDate;
    },
  },
};
</script>

<style></style>
